import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ManageClientAsset from './ManageClientAsset';
import MaintenanceLog from './MaintenanceLog';
import { Can } from '../../Context/Can';
import TabPanel from '@mui/lab/TabPanel/TabPanel';
import { Box, Grid, IconButton, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext/TabContext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TabList from '@mui/lab/TabList';
import ClientAssetList from './ClientAssetList';
import InventoryList from './InventoryList';
import InventortItemList from './InventoryItemList';

export default function AssetManagement() {

    const { client_id, tabId } = useParams();

    const tabNames = ['sale','leased-asset', 'treatment', 'distribution', 'inventory'];
    const navigate = useNavigate();
    const [value, setValue] = useState('1');

    useEffect(() => {
        setValue(tabId)
    }, [tabId]);

    const handleTabSwitch = (event, newValue) => {
        if ( localStorage.getItem('clientAssetTabId') ) {
            localStorage.removeItem('clientAssetTabId');
        }
        if ( localStorage.getItem('inventoryQueryParams') ) {
            localStorage.removeItem('inventoryQueryParams');
        }
        setValue(newValue);
        navigate(client_id ? `/client/${client_id}/client-assets/${newValue}` : `/inventory-management/${newValue}`)
    }; 

    let found = false;
    for (const tabName of tabNames) {
        if (window.location.pathname.includes(tabName)) {
            found = true;
            break;
        }
    }

    if (!found) {
        navigate('/page-not-found');
    }

    return <>
        <Grid>
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box id="digital-twin-tab-container" sx={{ borderBottom: 1, borderColor: 'divider',  display: 'flex', alignItems: 'center', margin: '0px 24px' }}>
                        <TabList 
                        sx={{
                            '& .MuiTabs-scrollButtons.Mui-disabled': {
                              display: 'none',
                            },
                          }}
                        onChange={handleTabSwitch} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto">
                            {(!client_id) && (<Tab label="Inventory Name" value="inventory" />)}
                            {(!client_id) && (<Tab label="Inventory Item" value="inventory-item" />)}
                            <Tab label="Leased Assets" value="leased-asset" />
                            <Tab label="Sale" value="sale" />
                            {(!client_id) && (<Tab label="Quarantine" value="quarantine" />)}
                            {(!client_id) && (<Tab label="Scrap" value="scrap" />)}
                            {(!client_id) && (<Tab label="Repair & Reuse" value="repair-reuse" />)}
                            <Tab label="Treatment" value="treatment" />
                            <Tab label="Distribution" value="distribution" />
                        </TabList>
                    </Box>
                    <TabPanel style={{ padding: '0px' }} value="leased-asset"><Can I="view" a="ClientAssets"><ClientAssetList /></Can></TabPanel>
                    <TabPanel style={{ padding: '0px' }} value="sale"><Can I="view" a="ClientAssets"><ClientAssetList /></Can></TabPanel>
                    <TabPanel style={{ padding: '0px' }} value="treatment"><Can I="view" a="ClientAssets"><ClientAssetList /></Can></TabPanel>
                    <TabPanel style={{ padding: '0px' }} value="distribution"><Can I="view" a="ClientAssets"><ClientAssetList /></Can></TabPanel>
                    {!client_id && (<TabPanel style={{ padding: '0px' }} value="inventory"><Can I="view" a="InventoryList"><InventoryList /></Can></TabPanel>)}
                    {!client_id && (<TabPanel style={{ padding: '0px' }} value="inventory-item"><Can I="view" a="InventoryItemList"><InventortItemList /></Can></TabPanel>)}
                </TabContext>
            </Box>
        </Grid>
    </>

}